import { render, staticRenderFns } from "./shops-admin-edit.vue?vue&type=template&id=3f97d960&scoped=true"
import script from "./shops-admin-edit.vue?vue&type=script&lang=js"
export * from "./shops-admin-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f97d960",
  null
  
)

export default component.exports